<template>

    <trax-ui-card-icon-header icon="assignment_turned_in" header-color="info" 
        :title="lang.polaris.dashboard.global_feedback" class="mt-5"
        v-if="showFeedbacks"
    >

        <form autocomplete="off" class="trax-form mb-4">

            <trax-ui-input :placeholder="lang.polaris.dashboard.comments" col="md-3"
                v-model="form.comments" :error="errors.comments" rows="5" required="1">
            </trax-ui-input>

        </form>
    </trax-ui-card-icon-header>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-course-session-edit'},
            source: {default: '2'},
            target: {default: 'final'}
        },

        data() {
            return {
                lang: lang,
                item: data.item,
                form: {
                    comments: '',
                },
                errors: {},
                bus: this.$bus
            }
        },
        
        created() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        computed: {

            showFeedbacks() {
                return this.item.meta.remedial
            }
        },

        methods: {

            setStates(states) {
                if (!states.summary) {
                    this.form.comments = '';
                    return;
                }
                this.form.comments = states.summary.data.comments;
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {
                this.errors = {};
                for (var prop in this.form) { data.summary[prop] = this.form[prop]; }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>
